/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {forwardRef} from 'react';
import {defineMessages} from 'react-intl';
import {Link} from 'react-router-dom';
import {Button} from 'react-bootstrap';
import {useFormatMessage} from 'app/hooks';
import DownIcon from 'icons/DownIcon';

const messages = defineMessages({
  title: {id: 'label.button.move-down', defaultMessage: 'Move Down'},
});

const MoveDownIconButton = (
  {variant = 'light', title = messages.title, href, ...props},
  ref
) => {
  const titleText = useFormatMessage(title, title.values);
  if (href) {
    return (
      <Button
        ref={ref}
        as={Link}
        to={href}
        variant={variant}
        title={titleText}
        {...props}
      >
        <DownIcon />
      </Button>
    );
  }
  return (
    <Button ref={ref} variant={variant} title={titleText} {...props}>
      <DownIcon />
    </Button>
  );
};
MoveDownIconButton.displayName = 'MoveDownIconButton';

export default forwardRef(MoveDownIconButton);
